import React from "react";
import "../assets/css/vasiDownloadCtaSection.css";

import appleIcon from "../assets/images/consumer_landing/AppleIcon.png";
import androidIcon from "../assets/images/consumer_landing/GoogleIcon.png";

export default function VasiDownloadCtaSection({
  iosUrl,
  androidUrl,
  onTrack,
  title = "Helping people grow, one dot at a time!",
}) {
  return (
    <section className="vasi-dlhero">
      <div className="vasi-dlhero__card">
        <h2 className="vasi-dlhero__title">{title}</h2>

        <div className="vasi-dlhero__btnRow">
          <a
            href={iosUrl}
            rel="noopener noreferrer"
            className="vasi-dlhero__btn"
            onClick={() => onTrack?.("Download for iPhone", "VaSi Download Hero")}
          >
            <div className="vasi-dlhero__btnContent">
            <span className="vasi-dlhero__icon" aria-hidden="true">
              <img
                src={appleIcon}
                alt=""
                className="vasi-dlhero__iconImg"
                loading="lazy"
              />
            </span>
            <span className="vasi-dlhero__label">Download for iPhone</span>
            </div>
          </a>

          <a
            href={androidUrl}
            rel="noopener noreferrer"
            className="vasi-dlhero__btn"
            onClick={() => onTrack?.("Download for Android", "VaSi Download Hero")}
          >
            <div className="vasi-dlhero__btnContent">
            <span className="vasi-dlhero__icon" aria-hidden="true">
              <img
                src={androidIcon}
                alt=""
                className="vasi-dlhero__iconImg"
                loading="lazy"
              />
            </span>
            <span className="vasi-dlhero__label">Download for Android</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
